export const objectToFormData = (obj) => {
  const pairs = Object.entries(obj);
  const data = new FormData();
  pairs.forEach((pair) => data.append(pair[0], pair[1]));
  return data;
};
